import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName"];
import { useTheme } from 'foundations-theming/utils';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { AbstractTextElement } from '../AbstractTextElement';
import { BigContextProvider } from './BigContextProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const Big = _ref => {
  let {
      tagName = 'span'
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  return /*#__PURE__*/_jsx(BigContextProvider, {
    abstractTextElementStyleOverrides: {
      fontSize: theme.typography['heading-100'].fontSize
    },
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'Big',
    children: /*#__PURE__*/_jsx(AbstractTextElement, Object.assign({
      tagName: tagName
    }, restProps))
  });
};
Big.displayName = 'Big';